import React from 'react';

function ColourGrid({ selectedColours, onColourSelect }) {
  const colours = [
    // Row 1
    { name: 'Pink', hex: '#ec4899' },
    { name: 'Coral Red', hex: '#f87171' },
    { name: 'Red', hex: '#dc2626' },
    { name: 'Orange', hex: '#ea580c' },
    // Row 2
    { name: 'Amber', hex: '#f59e0b' },
    { name: 'Lime', hex: '#84cc16' },
    { name: 'Emerald', hex: '#059669' },
    { name: 'Forest Green', hex: '#166534' },
    // Row 3
    { name: 'Cyan', hex: '#06b6d4' },
    { name: 'Teal', hex: '#0d9488' },
    { name: 'Royal Blue', hex: '#2563eb' },
    { name: 'Navy Blue', hex: '#1e3a8a' },
    // Row 4
    { name: 'Purple', hex: '#9333ea' },
    { name: 'Indigo', hex: '#4f46e5' },
    { name: 'Charcoal', hex: '#374151' },
    { name: 'Black', hex: '#000000' }
  ];

  const isInactive = (colour) => {
    return selectedColours.length >= 2 && !selectedColours.includes(colour.hex);
  };

  return (
    <div className="grid grid-cols-4 gap-4">
      {colours.map((colour) => (
        <div key={colour.hex} className="text-center">
          <button
            onClick={() => !isInactive(colour) && onColourSelect(colour.hex)}
            disabled={isInactive(colour)}
            className={`w-full h-12 rounded-lg transition-all duration-200 hover:scale-105 colour-option ${
              selectedColours.includes(colour.hex)
                ? 'selected'
                : isInactive(colour)
                ? 'inactive'
                : 'hover:border-gray-400'
            }`}
            style={{ backgroundColor: colour.hex }}
            title={colour.name}
          />
          <p className="text-sm text-gray-600 mt-1 font-medium">{colour.name}</p>
        </div>
      ))}
    </div>
  );
}

export default ColourGrid;